export const arrayToCommaSeparatedString = (arr: string[]): string =>
  arr.join(',')
